import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { OrderTemplateDetailEntity } from '../domains/entities/orderTemplate';
import { OrderTemplateAdapter } from '../adapters/orderTemplateAdapter';
import { OrderTemplateUpsertRequest } from '@/coreInfrastructureModule/axios/generated/orderManage/api';

/**
 * 発注テンプレートを更新するユースケース
 */
export class UpdateOrderTemplateUseCase {
  /**
   * コンストラクタ
   * @param repository - 発注テンプレートを更新するリポジトリ
   */
  constructor(private readonly repository: IOrderTemplateRepository) {}

  /**
   * テンプレートを更新する
   * @param templateId - テンプレートID
   * @param request - 更新内容
   */
  public Execute = async (
    templateId: string,
    request: OrderTemplateUpsertRequest
  ): Promise<INetworkResult<OrderTemplateDetailEntity, IError>> => {
    const result = await this.repository.update(templateId, request);
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: OrderTemplateAdapter.toDetailEntity(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
